// can throw Uncaught Error: Invalid site key or not loaded in api.js: 6LdvXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX

// uncaught null means "Challenge cancelled by user"

// function grecaptchaExecute(recaptchaSiteKey, options) {
//   return new Promise((resolve, reject) => {
//     window.grecaptcha
//       .execute(recaptchaSiteKey, options)
//       .then(output => {
//         console.log("grecaptchaExecute: resolve", output)
//         return resolve(output)
//       })
//       .catch(error => {
//         console.error("grecaptchaExecute: error", error)
//         return reject(new Error("my error"))
//       })
//   })
// }

function waitForGrecaptchaScript () {
  return new Promise((resolve, reject) => {
    if (window.grecaptcha) {
      resolve()
    } else {
      const scriptObject = document.querySelector('#grecaptcha-js-script')

      if (!scriptObject) {
        reject(new Error('no <script id="grecaptcha-js-script"> on page'))
      }

      scriptObject.addEventListener('load', () => {
        resolve()
      })
    }
  })
}

// dont use it, fails
function grecaptchaReady () {
  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(resolve)
  })
}

// use this
export async function waitForGrecaptchaScriptLoadedAndReady () {
  await waitForGrecaptchaScript()
  await grecaptchaReady()
}

export function getRecaptchaSiteKeyOrThrow () {
  const { recaptchaSiteKey } = document.body.dataset
  if (!recaptchaSiteKey) {
    throw new Error(
      `Recaptcha public key should be present on body, but is empty: ${recaptchaSiteKey}`,
    )
  }
  return recaptchaSiteKey
}

export function googleRecaptcha_disabled (recaptchaSiteKey) {
  return recaptchaSiteKey === 'RECAPTCHA_SITE_KEY__NOT_REAL_DISABLE'
}

export const googleRecaptcha_disabled_tokenReturnedByJs = 'RECAPTCHA_JS_TOKEN__NOT_REAL_DISABLE'

export function googleRecaptcha_getRecaptchaSiteKeyOrThrow_disabled () {
  return googleRecaptcha_disabled(getRecaptchaSiteKeyOrThrow())
}

export async function googleRecaptchaRenderWidget (id) {
  if (!id) {
    throw new Error(`id is empty: ${id}`)
  }

  const recaptchaSiteKey = getRecaptchaSiteKeyOrThrow()

  if (googleRecaptcha_disabled(recaptchaSiteKey)) {
    console.log(
      `googleRecaptchaRenderWidget: returning ${googleRecaptcha_disabled_tokenReturnedByJs}`,
    )
    // Probably we are in Rails.env.test?
    return null
  }

  console.log('googleRecaptchaRenderWidget:', {
    recaptchaSiteKey,
    id,
  })

  await waitForGrecaptchaScriptLoadedAndReady()

  if (!document.getElementById(id)) {
    throw new Error(`no element with id ${id}`)
  }

  const grecaptchaWidget = window.grecaptcha.render(id, {
    sitekey: recaptchaSiteKey,
    callback: (token) => {
      console.log('callback', { token })
    },
    'expired-callback': () => {
      console.log('expired-callback is fired')
    },
    'error-callback': (arg1, arg2) => {
      console.log('error-callback', {
        arg1,
        arg2,
      })
    },
  })

  return grecaptchaWidget
}

export function grecaptchaGetResponseOrDisableForTests (grecaptchaWidget) {
  const recaptchaSiteKey = getRecaptchaSiteKeyOrThrow()

  if (googleRecaptcha_disabled(recaptchaSiteKey)) {
    if (grecaptchaWidget !== null) {
      throw new Error('grecaptchaWidget should be null')
    }
    console.log(
      `grecaptchaGetResponseOrDisableForTests: returning ${googleRecaptcha_disabled_tokenReturnedByJs}`,
    )
    // Probably we are in Rails.env.test?
    return googleRecaptcha_disabled_tokenReturnedByJs
  }

  if (grecaptchaWidget === null) {
    throw new Error(
      'grecaptchaGetResponseOrDisableForTests: grecaptchaWidget should be not null',
    )
  }
  const grecaptchaToken = window.grecaptcha.getResponse(grecaptchaWidget)
  return grecaptchaToken
}

// export async function googleRecaptchaTokenForAction(action) {
//   if (!action) {
//     throw new Error(`action is empty: ${action}`)
//   }
//
//   const { recaptchaSiteKey } = document.body.dataset
//
//   if (!recaptchaSiteKey) {
//     throw new Error(
//       `Recaptcha public key should be present on body, but is empty: ${recaptchaSiteKey}`,
//     )
//   }
//
//   if (recaptchaSiteKey === "RECAPTCHA_SITE_KEY__NOT_REAL_DISABLE") {
//     console.log(
//       `googleRecaptchaTokenForAction: returning ${googleRecaptcha_disabled_tokenReturnedByJs}`,
//     )
//     // Probably we are in Rails.env.test?
//     return googleRecaptcha_disabled_tokenReturnedByJs
//   }
//
//   console.log("googleRecaptchaTokenForAction:", { recaptchaSiteKey, action })
//
//   await waitForGrecaptchaScriptLoadedAndReady()
//
//   console.log("googleRecaptchaTokenForAction: ready done")
//
//   const promise = grecaptchaExecute(recaptchaSiteKey, { action })
//
//   console.log("googleRecaptchaTokenForAction: promise", promise)
//
//   const response = await promise
//
//   console.log("googleRecaptchaTokenForAction: response", response)
//
//   return response
// }
